/* global bsBreakpoints */
(() => {
  const header = document.querySelector("[data-js-header]");

  const addClassFront = () => {
    if (window.scrollY > 600) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  };

  const scrollHeader = () => {
    if (document.querySelector("body").classList.contains("front")) {
      document.onscroll = function () {
        const submenus = header.querySelectorAll(".header__submenu-lvl1");
        const blockHeight = 600;
        submenus.forEach((submenu) => {
          if (window.scrollY < 600) {
            const viewportHeight = window.innerHeight;
            const scrollY = window.scrollY;
            const menuHeight = viewportHeight - blockHeight + scrollY;
            submenu.style.height = `${menuHeight}px`;
          }
        });
        addClassFront();
      };
      addClassFront();
    } else {
      header.classList.add("scrolled");

      document.onscroll = function () {
        console.log(window.scrollY);
        if (window.scrollY > 90) {
          header.classList.add("scrolled-notfront");
        } else {
          header.classList.remove("scrolled-notfront");
        }
      };
    }
  };

  const init = () => {
    if (header) {
      scrollHeader();
    }
  };

  init();
})();
